
    const data = {"name":"src/core/icons/checkbox-marked-circle","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m10 17-5-5 1.41-1.42L10 14.17l7.59-7.59L19 8m-7-6A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            